"use client";

interface FormProgressBarProps {
  currentStep: number;
  totalSteps: number;
  currentSection: 1 | 2 | 3;
  sectionLabels: string[];
}

export default function FormProgressBar({
  currentStep,
  totalSteps,
  currentSection,
  sectionLabels,
}: FormProgressBarProps) {
  return (
    <div className="bg-surface shadow-sm border-t border-border">
      <div className="container mx-auto px-4 py-3 max-w-2xl mt-6">
        <div className="flex items-center justify-between">
          {/* Section Labels */}
          <div className="flex items-center gap-2 flex-1">
            {sectionLabels.map((label, index) => {
              const sectionNum = (index + 1) as 1 | 2 | 3;
              const isActive = sectionNum === currentSection;
              const isCompleted = sectionNum < currentSection;

              return (
                <div key={sectionNum} className="flex items-center flex-1">
                  <div className="flex items-center gap-2">
                    <div
                      className={`rounded-full h-8 w-8 flex items-center justify-center text-sm font-medium transition-colors ${
                        isCompleted
                          ? "bg-primary text-white"
                          : isActive
                            ? "bg-primary text-white ring-2 ring-primary ring-offset-2"
                            : "bg-tertiary text-text-light"
                      }`}
                    >
                      {sectionNum}
                    </div>
                    <span
                      className={`text-sm font-medium hidden sm:inline ${
                        isActive ? "text-primary" : "text-text-light"
                      }`}
                    >
                      {label}
                    </span>
                  </div>
                  {index < sectionLabels.length - 1 && (
                    <div
                      className={`h-1 flex-1 mx-2 transition-colors ${
                        isCompleted ? "bg-primary" : "bg-tertiary"
                      }`}
                    />
                  )}
                </div>
              );
            })}
          </div>

          {/* Step Counter */}
          <div className="ml-4 text-sm text-text-light font-medium">
            Step {currentStep} of {totalSteps}
          </div>
        </div>
      </div>
    </div>
  );
}
